/* import React from "react";

export const BoothSettings = (props) => {};

const CategorySection = () => {
  return <section></section>;
};

const CategoryHeader = () => {
  return <header></header>;
};

const CategoryBody = () => {
  return <div></div>;
}; */

import { Button, Divider, FormGroup, List } from "@material-ui/core";
import React from "react";
import { Label, Input, Row, Col } from "reactstrap";
import ImageIcon from "@material-ui/icons/Image";

import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import EventLabel2 from "../../../../components/EventLabel2/EventLabel2";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import { embedLink } from "../../../../helpers/embed.helper";
import { faYoutube, faDailymotion, faVimeoSquare } from "@fortawesome/free-brands-svg-icons";
import { combineProps } from "../../../../helpers/objectHelper";
import { GenericPlayer } from "../../../../plugins/GenericPlayer";
import ExhibitorEditor from "../../../../components/TinyMCE/ExhibitorEditor";
import PopEditorClassic from "../../../../components/TinyMCE/PopEditorClassic";
import JirangoSwitch from "../../../../components/JirangoSwitch/JirangoSwitch";

const filteredSettings = ["File", "Link"];
const fileUpload = ["LogoImage"];
const switches = ["EnableVideoMeeting", "EnableChat"];
const video = ["StartVideo"];
const number = ["VideoCallTimeout"];
const editor = ["Infotext"];

const categories = [
  { name: "Content", options: ["LogoImage", "Infotext", "StartVideo"] },
  {
    name: "Chat",
    options: ["EnableChat", "EnableVideoMeeting", "VideoCallTimeout"],
  },
];

const FileUploadItem = (props) => {
  const { onUpload, exhibitorSettingId, value, name } = props;
  return (
    <div>
      <label htmlFor="file-upload" style={{ position: "relative" }}>
        <div
          className="mock-button"
          style={{
            height: 100,
            width: 200,
            border: !value ? "1px dashed #ccc" : 0,
            background: !value ? "#eee" : "none",
            position: "relative",
            borderRadius: 4,
          }}
        >
          {!value ? <ImageIcon className="centered-text" style={{ color: "#ccc" }} /> : null}
          <img src={value} style={{ maxWidth: "100%", height: "auto", maxHeight: "100%" }} />
        </div>
      </label>
      <div style={{ position: "relative" }}>
        <input accept="pdf,svg,png,jpg,jif" id="file-upload" className="file-upload" type="file" onChange={(e) => onUpload(e, exhibitorSettingId, name)} />
      </div>
    </div>
  );
};

const TextEditorItem = (props) => {
  const { value2, exhibitorSettingId, setSavable, onEdit } = props;
  return (
    /*     <div style={{ marginBottom: 10 }}> */
    <ExhibitorEditor
      value={value2}
      editMode={true}
      onChange={(e) => {
        onEdit(exhibitorSettingId, "value2", e);
        setSavable(true);
      }}
      expo={true}
      showLinkEditor={false}
      sourceCode={false}
      slimFormat={true}
      path={"value2"}
      style={{
        height: "500px",
      }}
    />
    /*     </div> */
  );
};

const SwitchItem = (props) => {
  const { name, setSavable, exhibitorSettingId, value2, onEdit } = props;
  return (
    <div style={{ display: "flex", marginRight: "100%", marginTop: "5px" }}>
      <JirangoSwitch
        onChange={() => {
          onEdit(exhibitorSettingId, "value2", value2 == "True" ? "False" : "True");
          setSavable(true);
        }}
        isChecked={value2 == "True" ? true : false}
      />
    </div>
  );
};

const VideoItem = (props) => {
  const { exhibitorSettingId, value2, onEdit, setSavable, name } = props;
  return (
    <div style={{ width: 400 }}>
      <div
        style={{
          height: 200,
          width: 400,
          border: !value2 ? "1px dashed #ccc" : 0,
          background: !value2 ? "#eee" : "#222",
          position: "relative",
          borderRadius: 4,
          marginBottom: 10,
        }}
      >
        {!value2 ? <PlayCircleOutlineIcon className="centered-text" style={{ color: "#ccc", fontSize: 70 }} /> : <GenericPlayer {...combineProps([{ url: /* embedLink( */value2/* ) */, clickTrack: false }])} />}
      </div>
      <Input
        onChange={(e) => {
          onEdit(exhibitorSettingId, "value2", e.target.value);
          setSavable(true);
        }}
        value={value2}
      />
      {/*   <p className="text-muted" style={{ margin: 0 }}>
        <SystemLabel name={name} />{" "}
      </p>
      <div style={{ display: "flex" }}>
        <FontAwesomeIcon
          icon={faVimeoSquare}
          style={{ marginRight: 5, fontSize: 30, color: "rgb(0, 173, 239)" }}
        />
        <FontAwesomeIcon
          icon={faYoutube}
          style={{ marginRight: 5, fontSize: 30, color: "#f00" }}
        />
        <FontAwesomeIcon
          icon={faDailymotion}
          style={{ marginRight: 5, fontSize: 30, color: "#222" }}
        />
      </div> */}
    </div>
  );
};

const NumberItem = (props) => {
  const { exhibitorSettingId, value2, onEdit, setSavable, name } = props;
  return (
    <div style={{ width: 120 }}>
      <Input
        onChange={(e) => {
          onEdit(exhibitorSettingId, "value2", e.target.value);
          setSavable(true);
        }}
        value={value2}
      />
      {/*    <p className="text-muted">
        <SystemLabel name={name} />{" "}
      </p> */}
    </div>
  );
};

export function BoothSettings(props) {
  const { renderIcon, settings, isSavable } = props;
  return (
    <div>
      <List
        className="booth-settings-list"
        style={{
          maxHeight: "calc(100vh - 157px)",
          minHeight: "calc(100vh - 157px)",
          overflowX: "hidden",
          padding: 10,
        }}
      >
        {categories.map((c, i) => {
          return (
            <div key={i}>
              <div className="category-header">
                <EventLabel2 name={c.name} groupName="Exhibitor.Admin" />
              </div>
              <div>
                {c.options.map((o, oi) => {
                  const setting = settings.find((s) => s.name == o);
                  return (
                    <div style={{ margin: 15, marginTop: 20 }} key={setting.exhibitorSettingId}>
                      <Row>
                        <Col className="col-4">
                          <FormGroup
                            style={{
                              flexDirection: switches.includes(setting.name) || number.includes(setting.name) ? "row" : "column",
                            }}
                          >
                            <Label
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                marginRight: switches.includes(setting.name) || number.includes(setting.name) ? "25px" : "0px",
                              }}
                            >
                              <span
                                style={{
                                  fontWeight: 600,
                                }}
                              >
                                <EventLabel2 name={setting.name} groupName="Exhibitor.Admin" />
                              </span>
                              <span>
                                <EventLabel2 name={setting.name + "Details"} groupName="Exhibitor.Admin" />
                              </span>
                            </Label>
                          </FormGroup>
                        </Col>
                        <Col className={"col-8"} >
                          {" "}
                          <ListItem {...combineProps([props, setting])} />{" "}
                        </Col>
                      </Row>

                      {oi != c.options.length - 1 ? <Divider /> : null}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
        {/*  {settings
        .sort((a, b) => {
          return a.sortOrder - b.sortOrder;
        })
        .filter((s) => !filteredSettings.includes(s.name))
        .map((s, i) => {
          const { name } = s;
          const ps = { ...s, ...props };
          return (
            <div key={i} style={{ margin: 15 }}>
              <FormGroup
                style={{
                  flexDirection: switches.includes(name) ? "row" : "column",
                }}
              >
                <Label>
                  <EventLabel2 name={name} groupName="Exhibitor.Admin" />
                </Label>
                <ListItem {...ps} />
              </FormGroup>
            </div>
          );
        })} */}
      </List>
    </div>
  );
}

const ListItem = (props) => {
  const { name } = props;
  if (fileUpload.includes(name)) {
    return <FileUploadItem {...props} />;
  }
  if (video.includes(name)) {
    return <VideoItem {...props} />;
  }
  if (number.includes(name)) {
    return <NumberItem {...props} />;
  }
  if (switches.includes(name)) {
    return <SwitchItem {...props} />;
  }
  if (editor.includes(name)) {
    return <TextEditorItem {...props} />;
  }
  return null;
};
